import React, { useState, useCallback, useMemo } from "react";
import {
  Pagination,
  Select,
  MenuItem,
  TextField,
  Button,
  Box,
} from "@mui/material";
import "./pagination.css";
import { styled } from "@mui/system";

const StyledSelect = styled(Select)(({ theme }) => ({
  minWidth: "80px",
  height: "30px",
  borderRadius: "100px",
  marginLeft: "8px",
}));

const PaginationComponent = ({
  page,
  setPage,
  totalPages,
  rowsPerPage,
  setRowsPerPage,
}) => {
  const [goToPage, setGoToPage] = useState("");

  const rowOptions = useMemo(() => [15, 20, 25], []);

  const handlePageChange = useCallback((event, value) => {
    setPage(value);
  }, [setPage]);

  const handleGoToPage = useCallback(() => {
    const pageNumber = Number(goToPage);
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber);
    }
  }, [goToPage, setPage, totalPages]);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Enter") {
        handleGoToPage();
      }
    },
    [handleGoToPage]
  );

  return (
    <Box display="flex" alignItems="center" justifyContent="center" gap={2} mt={2}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        variant="outlined"
        shape="rounded"
        className="styled-pagination"
      />
      <Box className="styled-text">Show</Box>
      <StyledSelect
        value={rowsPerPage}
        onChange={(e) => setRowsPerPage(e.target.value)}
      >
        {rowOptions.map((rows) => (
          <MenuItem key={rows} value={rows}>
            {rows} rows
          </MenuItem>
        ))}
      </StyledSelect>

      {totalPages > 1 && (
        <>
          <Box className="styled-text">Go to page</Box>
          <TextField
            variant="outlined"
            value={goToPage}
            type="number"
            onChange={(e) => setGoToPage(e.target.value)}
            onKeyDown={handleKeyDown}
            className="styled-textfield"
          />
          <Button onClick={handleGoToPage} id="styled-button">
            Go
          </Button>
        </>
      )}
    </Box>
  );
};

export default PaginationComponent;
